<template>
  <div class="myaccount">
    <ui-button
      v-if="!isLogged()"
      ref="loginIcon"
      icon="arrow-out-circle"
      @click="open()"
      text
      >login</ui-button
    >
    <ui-button
      v-if="isLogged()"
      ref="accountIcon"
      markup="router-link"
      :to="{ name: 'account' }"
      text
      icon="user-circle"
      key="header-account-icon"
      >Mon compte</ui-button
    >
  </div>
</template>
<script>
import UiButton from "@/components/ui/UiButton.vue";
import UserStore from "@/store/userStore";
import { EventBus } from "@/mixins/event-bus";
export default {
  components: { UiButton },
  methods: {
    open() {
      if (!["register", "login"].includes(this.$route.name)) {
        EventBus.$emit("openLoginModal");
      }
    },
    isLogged() {
      return UserStore.state.logged;
    },
  },
};
</script>
